/* istanbul ignore file */
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Route } from 'react-router-dom';
import { AssignmentRouter } from './assignment';
import BenchRouter from './assignment/bench/BenchRouter';
import StaffingProjectRouter from './project/StaffingProjectRouter';
import StaffingDashboardRouter from './dashboard/StaffingDashboardRouter';
import StaffingOpportunityRouter from './dashboard/opportunityDashboard/OpportunityDashboardRouter';

const StaffingRouter = () => {
  const { isAuthenticated } = useAuthenticationService();

  return [
    <Route path={AssignmentRouter.getRouterPath()} element={<AssignmentRouter />} />,
    <Route path={BenchRouter.getRouterPath()} element={<BenchRouter />} />,
    <Route path={StaffingProjectRouter.getRouterPath()} element={<StaffingProjectRouter />} />,
    <Route path={StaffingDashboardRouter.getRouterPath()} element={<StaffingDashboardRouter />} />,
    <Route path={StaffingOpportunityRouter.getRouterPath()} element={<StaffingOpportunityRouter />} />,
    <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />,
  ];
};

export default StaffingRouter;
